import React from "react";

/**
 * BrandMark — the master Neo Brightwell / Moonshine Disco mark.
 * Renders the NB Skull + Disco Globe artifact, with subtle warm glow.
 */
// Served from the app's own /public directory so this bundle has zero
// runtime dependencies on Emergent's CDN — remains portable to any host.
export const NB_SKULL_URL = "/brand/nb-skull.png";

export const BrandMark = ({ size = 32, className = "", glow = true }) => (
  <img
    src={NB_SKULL_URL}
    alt="Neo Brightwell — Moonshine Disco mark"
    width={size}
    height={size}
    className={className}
    style={{
      width: size,
      height: size,
      objectFit: "contain",
      filter: glow
        ? "drop-shadow(0 0 12px rgba(199,168,106,0.28))"
        : "none",
    }}
  />
);

export default BrandMark;
